'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadCard = exports.LeadCardUnwrapped = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var ReduxForm = _interopRequireWildcard(_reduxForm);

var _decorator = require('helpers/decorator');

var _ConsentMessage = require('components/Consent/ConsentMessage');

var _ApiError = require('components/Errors/ApiError');

var _Heading = require('components/Heading/Heading');

var _Section = require('components/Section/Section');

var _FacebookForm = require('../forms/FacebookForm');

var _LeadForm = require('../forms/LeadForm');

var _SignupCardCta = require('../forms/SignupCardCta');

var _lead = require('../sagas/lead.saga');

var _facebook = require('../sagas/facebook.saga');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var messages = (0, _reactIntl.defineMessages)({
  stepTitle: {
    id: 'signup-card.lead.step-title',
    defaultMessage: 'Enter your email to continue'
  }
});

var LeadCardUnwrapped = exports.LeadCardUnwrapped = function LeadCardUnwrapped(_ref) {
  var error = _ref.error,
      hasFacebookSucceeded = _ref.hasFacebookSucceeded,
      hasLeadSucceeded = _ref.hasLeadSucceeded,
      hiddenFields = _ref.hiddenFields,
      isFacebookSubmitting = _ref.isFacebookSubmitting,
      isLeadIncomplete = _ref.isLeadIncomplete,
      isLeadSubmitting = _ref.isLeadSubmitting,
      onFacebookSuccess = _ref.onFacebookSuccess,
      onLeadSuccess = _ref.onLeadSuccess,
      tag = _ref.tag,
      terms = _ref.terms;
  return _react2.default.createElement(
    'div',
    { className: 'card' },
    _react2.default.createElement(
      _Section.Section,
      { className: 'SignupCard SignupCard--lead-step' },
      tag && _react2.default.createElement(
        'div',
        { className: 'SignupCard__tag' },
        _react2.default.createElement(
          'span',
          null,
          tag
        )
      ),
      error && _react2.default.createElement(
        'div',
        { className: 'SignupCard__error' },
        _react2.default.createElement(_ApiError.ApiError, { error: error })
      ),
      _react2.default.createElement(
        'header',
        null,
        _react2.default.createElement(
          _Heading.Heading,
          { className: 'SignupCard__title' },
          _react2.default.createElement(_reactIntl.FormattedMessage, messages.stepTitle)
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'SignupCard__form' },
        _react2.default.createElement(_LeadForm.LeadForm, {
          formId: _lead.LEAD_FORM,
          hiddenFields: hiddenFields,
          onSuccess: onLeadSuccess
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'SignupCard__cta' },
        _react2.default.createElement(_SignupCardCta.SignupCardCta, {
          formId: _lead.LEAD_FORM,
          isDisabled: !!(false || hasFacebookSucceeded || hasLeadSucceeded || isFacebookSubmitting || isLeadIncomplete),
          isSubmitting: !!isLeadSubmitting
        })
      ),
      _react2.default.createElement('hr', { className: 'SignupCard__form-separator' }),
      _react2.default.createElement(
        'div',
        { className: 'SignupCard__form' },
        _react2.default.createElement(_FacebookForm.FacebookForm, {
          hiddenFields: hiddenFields,
          isDisabled: !!(false || hasFacebookSucceeded || hasLeadSucceeded || isLeadSubmitting),
          onSuccess: onFacebookSuccess
        })
      ),
      terms && _react2.default.createElement(
        'div',
        { className: 'SignupCard__terms' },
        _react2.default.createElement(_ConsentMessage.ConsentMessage, { message: terms })
      )
    )
  );
};

LeadCardUnwrapped.propTypes = {
  error: _ApiError.ApiError.propTypes.error,
  hiddenFields: _propTypes2.default.object,
  hasFacebookSucceeded: _propTypes2.default.bool,
  hasLeadSucceeded: _propTypes2.default.bool,
  isFacebookSubmitting: _propTypes2.default.bool,
  isLeadIncomplete: _propTypes2.default.bool,
  isLeadSubmitting: _propTypes2.default.bool,
  onFacebookSuccess: _propTypes2.default.func.isRequired,
  onLeadSuccess: _propTypes2.default.func.isRequired,
  tag: _propTypes2.default.node,
  terms: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    error: ReduxForm.getFormError(_lead.LEAD_FORM)(state) || ReduxForm.getFormError(_facebook.FACEBOOK_FORM)(state),
    hasFacebookSucceeded: ReduxForm.hasSubmitSucceeded(_facebook.FACEBOOK_FORM)(state),
    hasLeadSucceeded: ReduxForm.hasSubmitSucceeded(_lead.LEAD_FORM)(state),
    isFacebookSubmitting: ReduxForm.isSubmitting(_facebook.FACEBOOK_FORM)(state),
    isLeadIncomplete: ReduxForm.isInvalid(_lead.LEAD_FORM)(state),
    isLeadSubmitting: ReduxForm.isSubmitting(_lead.LEAD_FORM)(state),
    terms: (ReduxForm.getFormValues(_facebook.FACEBOOK_FORM)(state) || {}).terms
  };
};

var LeadCard = exports.LeadCard = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), (0, _decorator.withName)('LeadCard'))(LeadCardUnwrapped);